import React, { useEffect, useState } from 'react';
import { AlarmClock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { joApi } from '@/services/processingJoApi';

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

/** Alert strip: open job orders past their expected delivery date (and how many fall due in 2 days). */
export const JoOverdueBanner = ({ onView, refreshKey = 0, testId = 'jo-overdue-banner' }) => {
  const [a, setA] = useState(null);
  useEffect(() => { joApi.alerts().then(setA).catch(() => {}); }, [refreshKey]);
  if (!a || (!a.overdue_count && !a.due_soon_count)) return null;
  const late = a.overdue_count > 0;
  return (
    <div className={`rounded-lg border px-4 py-3 flex flex-wrap items-center gap-3 ${late ? 'border-rose-200 bg-rose-50' : 'border-amber-200 bg-amber-50'}`} data-testid={testId}>
      <AlarmClock className={`w-5 h-5 shrink-0 ${late ? 'text-rose-600' : 'text-amber-600'}`} />
      <div className="min-w-0 flex-1">
        <p className={`text-sm font-semibold ${late ? 'text-rose-900' : 'text-amber-900'}`} data-testid={`${testId}-text`}>
          {late ? `${plural(a.overdue_count, 'Processing job order is', 'Processing job orders are')} past the expected delivery date` : ''}
          {late && a.due_soon_count ? ' · ' : ''}
          {a.due_soon_count ? `${plural(a.due_soon_count, 'order falls', 'orders fall')} due in the next 2 days` : ''}
        </p>
        {late && <p className="text-xs text-rose-800/80 truncate" data-testid={`${testId}-list`}>
          {a.overdue.map((o) => `${o.jo_id} · ${o.fg_name} · ${o.days_late}d late · ${o.pending_pcs} pcs pending`).join('   |   ')}</p>}
      </div>
      {late && onView && <Button size="sm" onClick={onView} className="bg-rose-600 hover:bg-rose-700 text-white" data-testid={`${testId}-view-btn`}>View overdue</Button>}
    </div>
  );
};

export default JoOverdueBanner;
